import {useState, useEffect} from 'react'

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import AccordionGroup from 'components/Accordion/AccordionGroup'

import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

/* eslint-disable react/prop-types */
export default function ModalSurveyData({survey}) {
      
    return (
        <>
        {survey && 
            <Grid container spacing={1} width={"30rem"} height={"30rem"}>
                <Grid item xs={12} >
                    <MDBox display="block" alignItems="center" lineHeight={1} pt={1} pl={2} pr={2}>
                        <MDBox ml={2} mr={1} lineHeight={1}>
                            <MDTypography variant="caption" fontWeight="medium">{"Survey questions"}</MDTypography>
                        </MDBox>
                        <MDBox mt={2} ml={1} mr={1} lineHeight={1}>
                            <AccordionGroup data={survey['survey_questions']} system={(survey["survey_definition"]["survey_name"] === 'PERSONAL_DATA_SURVEY' || survey["survey_definition"]["survey_name"] === 'PRODUCT_DEFAULT_SURVEY')}/>
                        </MDBox>
                        {(survey["survey_definition"]["survey_name"] !== 'PERSONAL_DATA_SURVEY' && survey["survey_definition"]["survey_name"] !== 'PRODUCT_DEFAULT_SURVEY') &&
                        <MDBox mt={2} ml={1} mr={1} lineHeight={1}>
                            <MDButton variant="gradient" color="dark" size="small">
                                <MDTypography variant="caption" fontWeight="medium" color="light">{" + Add new question"}</MDTypography>
                            </MDButton>
                        </MDBox>
                        }
                    </MDBox>
                </Grid>
            </Grid>
            }
        </>


    );
}